module.exports = __webpack_public_path__ + "static/img/ljekarna_cubelac.b8455d9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/customers/ljekarna_cubelac.jpg
// module id = 6l/n
// module chunks = 0